export enum MedicalRecordFieldEnum {
  SkinType = 'SkinType',
  ConditionAge = 'ConditionAge',
  Symptoms = 'Symptoms',
  ChangesInAppearance = 'ChangesInAppearance',
  PriorTreatmentsOrEvaluations = 'PriorTreatmentsOrEvaluations',
  FormerSkinCancer = 'FormerSkinCancer',
  ImmunosuppressantUse = 'ImmunosuppressantUse',
  AdditionalDetails = 'AdditionalDetails',
  Diagnosis = 'Diagnosis',
  DifferentialDiagnosis = 'DifferentialDiagnosis',
  RecommendedClinicalAction = 'RecommendedClinicalAction',
  FollowUpPriority = 'FollowUpPriority',
  ClinicalAction = 'ClinicalAction',
  FamilyHistoryOfMelanoma = 'FamilyHistoryOfMelanoma',
  EvaluatedBy = 'EvaluatedBy',
  BreslowThickness = 'BreslowThickness',
  SecondaryDiagnosis = 'SecondaryDiagnosis',
  TertiaryDiagnosis = 'TertiaryDiagnosis',
  Note = 'Note',
  ContactedBy = 'ContactedBy',
  MedicationOrExposure = 'MedicationOrExposure',
  AlleviatingFactor = 'AlleviatingFactor',
  AggravatingFactor = 'AggravatingFactor',
  GeneralSymptom = 'GeneralSymptom',
  Disposition = 'Disposition',
  TentativeClinicalDiagnosis = 'TentativeClinicalDiagnosis',
  RiskFactors = 'RiskFactors',
  ObjectiveFindings = 'ObjectiveFindings',
  TimeSpentReviewing = 'TimeSpentReviewing',
  PatientResponseNote = 'PatientResponseNote',
  Created = 'Created',
  RegisteredBy = 'RegisteredBy',
  /**
   * One answered concept of a form-driven triage. Unlike every other member
   * this is not a fixed clinical field: a record carries as many of them as the
   * template authored, each named by its own `key`.
   */
  FormAnswer = 'FormAnswer',
}
